import React from 'react'

import UniversalFit from './UniversalFit'
import RequireVehicleInfo from './RequireVehicleInfo'
import GuaranteedFit from './GuaranteedFit'
import DoesNotFit from './DoesNotFit'

const VehicleFitment = props => {
  const { data } = props
  const { product, modifiers } = data

  let isGuaranteedFit = false
  if (
    modifiers &&
    modifiers.vehicle &&
    (
      modifiers.vehicle.isFit &&
      modifiers.vehicle.isFit === true
    )
  ) {
    isGuaranteedFit = true
  }

  let isUniversalFit = false
  if (
    product &&
    product.isUniversal === true &&
    !modifiers?.vehicle?.lockedFitment
  ) {
    isUniversalFit = true
  }

  let isRequireVehicleInfo = false
  if (
    modifiers &&
    !modifiers.vehicle
  ) {
    isRequireVehicleInfo = true
  }

  let doesNotFit = false
  if (
    modifiers &&
    modifiers.vehicle &&
    typeof modifiers.vehicle.isFit !== 'undefined' &&
    modifiers.vehicle.isFit === false
  ) {
    doesNotFit = true
  }

  return (
    <>
      {(isUniversalFit === false && doesNotFit === true) && (
        <DoesNotFit data={data} />
      )}
      {(isUniversalFit === false && isRequireVehicleInfo === true) && (
        <RequireVehicleInfo data={data} />
      )}
      {(isUniversalFit === true) && <UniversalFit data={data} />}
      {(isGuaranteedFit === true) && <GuaranteedFit data={data} />}
    </>
  )
}

export default VehicleFitment
